import { render, staticRenderFns } from "./CalendarioServizi.vue?vue&type=template&id=d0d7f464&"
import script from "./CalendarioServizi.vue?vue&type=script&lang=ts&"
export * from "./CalendarioServizi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports